

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface AutoCommunicationSettingsParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface AutoCommunicationSettings {
   
    id?: any;
    tenantId: any;
    branchId: any;
   
    moduleName:string;
    msgOccurance:string;
    actionPerformed:string;
    runImmediate:string;
    hrs:string;
    //messageFrom:string;
  minutes: string;
  days: string;
   // isActive:string;
  sentThrough: string;
  message: string;
  remainderName?: string;
    parameters?: AutoCommunicationSettingsParameter[];
    links?: any;
}


export abstract class AutoCommunicationSettingsData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<AutoCommunicationSettings[]>;
    abstract create(url: string, data: AutoCommunicationSettings[]): Observable<AutoCommunicationSettings[]>;
    abstract update(url: string, data: AutoCommunicationSettings): Observable<AutoCommunicationSettings>;
    abstract delete(url: string): Observable<any>;
}
